window.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        document.querySelectorAll('lord-icon').forEach(icon => {
            const root = icon.shadowRoot;
            if (root && root.querySelector('.primary')) {
                icon.classList.add('has-primary');
            }
        });
    }, 300);
});
